import { defineField, defineType } from "sanity";

const getVideoData = (value: string) => {
  let videoId: string | null = null;
  let videoError: string | null = null;

  // if the value has a match for a vimeo video id (9 numbers), use it
  const match = value?.match(/(\d{9})/);
  if (match) {
    videoId = match[1];
  }

  if (!videoId) {
    videoError = "Invalid Vimeo Video ID / URL";
  }

  return {
    videoId,
    videoError
  };
};

const options = [
  { title: "Video ID", value: "videoId" },
  { title: "Typeform Questionnaire ID", value: "typeformQuestionnaireId" }
];
export const programRelatedDataType = defineType({
  type: "object",
  name: "programRelatedData",
  title: "[NO USED] Program Related Data",
  description:
    "Questionnaire and Video ID's are stored in the backend, contact Bernhard for changes",
  fields: [
    defineField({
      name: "key",
      type: "string",
      title: "Key",
      options: {
        list: options
      }
    }),
    defineField({
      name: "value",
      type: "string",
      title: "Value"
    })
  ],
  preview: {
    select: {
      key: "key",
      value: "value"
    },
    prepare(selection) {
      const { key, value } = selection as { key?: string; value?: string };
      const isVideoId = key === "videoId";
      const video = isVideoId && value ? getVideoData(value) : null;

      return {
        title: options.find((option) => option.value === key)?.title ?? key,
        subtitle: value,
        media: () => {
          if (isVideoId && video) {
            return (
              <img
                src={`https://vumbnail.com/${video.videoId}_small.jpg`}
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover"
                }}
              />
            );
          }
          return null;
        }
      };
    }
  }
});
